import ReactDOM from 'react-dom';

/**
 * 모달(팝업) 포탈
 */

interface IModalPortal {
  children: React.ReactNode;
}

const ModalPortal = ({children}: IModalPortal) => {
  const el = document.getElementById('modal');
  if (!el) return null;
  return ReactDOM.createPortal(children, el);
};

export default ModalPortal;
